export default "__VITE_ASSET__CJsbe44i__"